import React from "react";

export default function OfferCarousel({ header, children, testid }) {
  return (
    <div>
      {header}
      <div className="card-grid mt-5 pt-1 pb-3" data-testid={testid}>{children}</div>
    </div>
  );
}
